import React, { Component } from "react";
import { MDBDataTable } from "mdbreact";

// Router
import { NavLink, withRouter } from "react-router-dom";

// Redux
import { connect } from "react-redux";
import { getAllIssues, getPendingIssues } from "../../redux/actions/issues";
import { showModal } from "./../../redux/actions/modal";

//Table Helper Controllers
import {
  filterTableData,
  filterDataByColumns,
  modifyIssuesTableRows,
  onTableFetchSelectChange,
  TableFetchSelect,
  tableFetchSelectOptions,
} from "./../../helpers/tableControllers";

// UI Components
import { Loader } from "../../UI/Loaders/Loaders";
import Tabs from "../Tabs/Tabs";

// Component Styles
import "./ManageIssues.css";
import PendingIssues from "./TabComponents/PendingIssues";
import { getAdminStatistics } from "../../redux/actions/stats";
export class ManageIssues extends Component {
  // Component State
  state = {
    activeTab: "all",
    tabs: [
      {
        name: "All Issues",
        id: "all",
        icon: "fas fa-bug",
        identifier: "issuesTab",
      },
      {
        name: "Pending Issues",
        id: "pending",
        icon: "fas fa-hourglass-start",
        identifier: "issuesTab",
      },
      {
        name: "Resolved Issues",
        id: "closed",
        icon: "fas fa-check-circle",
        identifier: "issuesTab",
      },
      {
        name: "Cancelled Issues",
        id: "open",
        icon: "fas fa-times-circle",
        identifier: "issuesTab",
      },
    ],
  };

  // Toggle Tab & Tab content for Data Table
  toggleTabContent = (content) => {
    this.setState({
      activeTab: content,
    });
  };

  // Open modal
  modalHandler = (modalData) => {
    this.props.showModal(modalData);
  };

  //Component Life Cycle Hooks
  componentDidMount() {
    // If user is not authenticated, redirect to login
    if (!this.props.isAuthenticated) {
      this.props.history.push("/login");
    }

    this.props.getAllIssues();
    this.props.getPendingIssues();
    this.props.getAdminStatistics();
  }

  //JSX Template
  render() {
    const {
      total_issue,
      total_issue_closed,
      total_issue_pending,
      total_issue_open,
    } = this.props.statsReducer.stats;
    const { tabs, activeTab } = this.state;

    let RenderedComponent = null;

    // Load Issues properties from Issues Reducer - Redux
    // let {allIssues} = this.props.issuesReducer;
    let { allIssuesTableData, loading, error } = this.props.allIssues;

    //  If issues object is null e.g. Initial component render before API fetch
    if (error || allIssuesTableData === undefined) {
      RenderedComponent = (
        <div className="centerLoader">
          <div className="grid__padding animated fadeInRight">
            <h4 className="center-txt">
              <i className="fas fa-bell" /> Unable to Fetch Exist Issues
            </h4>
          </div>
        </div>
      );
    } else if (loading) {
      RenderedComponent = <Loader text="Loading All Issues ..." />;
    } else if (allIssuesTableData) {
      // Verify that a issues object exists
      if (allIssuesTableData === undefined || allIssuesTableData === null) {
        RenderedComponent = (
          <div centerLoader>
            <div className="grid__padding animated fadeInRight">
              <h4 className="center-txt p-y-5">
                <i className="fas fa-bell" /> Problem Fetching Existing Issues,
                Please Reload the Page{" "}
              </h4>
            </div>
          </div>
        );
      } else if (allIssuesTableData.rows) {
        if (allIssuesTableData.rows.length > 0) {
          // If a issues object exists, filter the rows property to reflect selected Tab
          const tableName = "Issues";
          const actions = ["view"];
          const filteredData = filterTableData(
            allIssuesTableData,
            activeTab,
            tableName
          );
          const { columns, rows } = filteredData;
          let newRows = modifyIssuesTableRows(
            rows,
            tableName,
            actions,
            this.modalHandler
          );
          let columnFilteredTable = filterDataByColumns(
            {
              columns: columns,
              rows: newRows,
            },
            "exclude",
            ["issue_ref", "pub_date"]
          );
          allIssuesTableData = { ...columnFilteredTable };

          RenderedComponent = (
            <div className="grid__padding">
              <MDBDataTable
                responsive
                minimal="true"
                striped
                bordered
                hover
                data={allIssuesTableData}
              />
            </div>
          );
        } else {
          RenderedComponent = (
            <div className="centerLoader">
              <div className="grid__padding animated fadeInRight">
                <h4 className="center-txt p-y-5">
                  <i className="fas fa-bell" /> There are Currently No Issues to
                  Resolve
                </h4>
              </div>
            </div>
          );
        }
      }
    }

    return (
      <div className="ManageIssues datatable-wrapper animated fadeInRight">
        <div className="table-view">
          {/*Manage Issues Header*/}
          <div className="block-header">
            <div className="row">
              <div className="col-lg-12 col-md-6 col-sm-7 dashboard-title animated fadeInRight flex__row">
                <h3 className="m-l-1">
                  <aside className="rounder">
                    <i className="fas fa-bug" />
                  </aside>
                  &nbsp; Manage Issues
                </h3>

                <div className="breadcrumb__location">
                  <NavLink to="dashboard">
                    <h3 className="breadcrumb__location__title">Dashboard</h3>
                  </NavLink>
                  <span className="breadcrumb__location__icon">
                    <i className="fas fa-angle-double-right" />
                  </span>
                  <NavLink to="manage-issues">
                    <h3 className="breadcrumb__location__title">
                      Manage Issues
                    </h3>
                  </NavLink>
                </div>
              </div>
            </div>

            {/*User & Financial Stats*/}
            <div className="row clearfix mt-30 grid__padding">
              <div className="col-lg-3 col-md-6">
                <div className="card">
                  <div className="body text-center">
                    <h3 className="m-t-0">{total_issue}</h3>
                    <p className="text-muted">
                      Total Number of Issues Reported
                    </p>
                    <div className="progress progress-xs m-t-sm white bg">
                      <div
                        className="progress-bar success"
                        datatoggle="tooltip"
                        dataoriginaltitle="100%"
                        style={{ width: "100%" }}
                      />
                    </div>
                    {/* <small> Issues till date</small> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="card">
                  <div className="body text-center">
                    <h3 className="m-t-0">{total_issue_open}</h3>
                    <p className="text-muted">Total Number of Issues Open</p>
                    <div className="progress progress-xs m-t-sm white bg">
                      <div
                        className="progress-bar progress-bar-danger"
                        datatoggle="tooltip"
                        dataoriginaltitle="100%"
                        style={{ width: "100%" }}
                      />
                    </div>
                    {/* <small>2% higher than last month</small> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="card">
                  <div className="body text-center">
                    <h3 className="m-t-0">{total_issue_pending}</h3>
                    <p className="text-muted">Total Number of Issues Pending</p>
                    <div className="progress progress-xs m-t-sm white bg">
                      <div
                        className="progress-bar progress-bar-warning"
                        datatoggle="tooltip"
                        dataoriginaltitle="100%"
                        style={{ width: "100%" }}
                      />
                    </div>
                    {/* <small>15% of total number of issues</small> */}
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-md-6">
                <div className="card">
                  <div className="body text-center">
                    <h3 className="m-t-0">{total_issue_closed}</h3>
                    <p className="text-muted">
                      Total Number of Issues Resolved
                    </p>
                    <div className="progress progress-xs m-t-sm white bg">
                      <div
                        className="progress-bar progress-bar-success"
                        datatoggle="tooltip"
                        dataoriginaltitle="100%"
                        style={{ width: "100%" }}
                      />
                    </div>
                    {/* <small> 1% of total number of issues</small> */}
                  </div>
                </div>
              </div>
            </div>
            <Tabs onContentToggle={this.toggleTabContent} tabs={tabs} />
          </div>

          {/*Datatable*/}
          <div>
            {/* {RenderedComponent} */}
            {(() => {
              switch (this.state.activeTab) {
                case "all":
                  return (
                    <div
                      id="finance"
                      className="table-view animated speed-1x fadeInRight"
                    >
                      {/*Welcome Block*/}
                      <div className="block-header">
                        <div className="flex-row">
                          <div className="col-lg-6 col-md-6 col-sm-7 dashboard-title">
                            <h3 className="m-l-1">
                              <aside className="rounder">1</aside>
                              &nbsp; All Issues
                            </h3>
                          </div>

                          <div>
                            <div
                              className="m-l-1 m-r-1 m-b-1"
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                height: "30px",
                              }}
                            >
                              <TableFetchSelect
                                // style={{ marginRight: '20px' }}
                                label="Showing results for: "
                                id="table-fetch"
                                className="table-fetch-select"
                                onChange={(e) =>
                                  onTableFetchSelectChange(
                                    e,
                                    this.props.showModal,
                                    this.props.getAllIssues,
                                    "getAllIssues",
                                    `searchvalue=`
                                  )
                                }
                                options={[...tableFetchSelectOptions]}
                              />
                            </div>
                          </div>
                        </div>
                        <div>
                          {/*Datatable*/}
                          <div className="center-container">
                            {RenderedComponent}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                case "pending":
                  return (
                    <PendingIssues
                      data={this.props.pendingIssues}
                      showModal={this.props.showModal}
                    />
                  );
                default:
                  return;
              }
            })()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    authReducer: { isAuthenticated, loggedInUser },
    issuesReducer: { allIssues, pendingIssues },
    statsReducer,
  } = state;

  return {
    isAuthenticated,
    loggedInUser,
    allIssues,
    pendingIssues,
    statsReducer,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    getAllIssues,
    getPendingIssues,
    showModal,
    getAdminStatistics,
  })(ManageIssues)
);
